<template>
  <div class="bg-gray-100 rounded-lg overflow-hidden">
    <Pic :image="image"/>
    <div class="p-3">
      <div class="font-size-5 font-weight-bold text-primary">
        {{ title }}
      </div>
      <div class="font-size-2" v-html="description"/>
      <div class="mt-3">
        <div v-for="(button, i) in buttons" :key="i" class="mt-2">
          <Button
            id="mk-button-card"
            :label="button.label"
            :url="button.url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "components/Button";
import Pic from "components/Pic";
import { getQueryStringParams } from '../../lib/utils';

export default {
  name: "CardMessage",
  components: { Button, Pic },
  props: {
    image: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    buttons: {
      type: Array,
      required: false,
      validator(value) {
        if (!value) return true;
        return value.every(button => button.label && button.url);
      }
    }
  }
};
</script>
